import { ChevronDown, Award, Users, MapPin, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const HeroSection = () => {
  const scrollToServices = () => {
    const element = document.querySelector("#leistungen");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="hero-section" data-testid="hero-section">
      {/* Background Image */}
      <div className="hero-background">
        <img
          src="https://images.unsplash.com/photo-1570189046794-606e8291541d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxzb2NjZXIlMjB0cmFpbmluZyUyMG5pZ2h0fGVufDB8fHx8MTc3NDM2NDAzMnww&ixlib=rb-4.1.0&q=85"
          alt="Fußballtraining bei Nacht"
          className="w-full h-full object-cover"
        />
        <div className="hero-gradient" />
      </div>

      {/* Content */}
      <div className="hero-content">
        <div className="max-w-3xl">
          {/* Overline */}
          <p
            className="text-xs sm:text-sm uppercase tracking-[0.2em] text-[#c1ff72] font-semibold mb-4 animate-fade-in-up opacity-0 stagger-1"
            data-testid="hero-overline"
          >
            Personal Fussballtraining
          </p>

          {/* Main Headline */}
          <h1
            className="font-['Bebas_Neue'] text-5xl sm:text-7xl lg:text-[10vw] xl:text-[120px] uppercase tracking-tighter leading-[0.9] text-white mb-6 animate-fade-in-up opacity-0 stagger-2"
            data-testid="hero-headline"
          >
            DEIN WEG
            <br />
            <span className="text-[#c1ff72]">ZUM ERFOLG</span>
          </h1>

          {/* Subheadline */}
          <p
            className="text-base sm:text-lg lg:text-xl text-[#A1A1AA] font-light leading-relaxed max-w-xl mb-8 animate-fade-in-up opacity-0 stagger-3"
            data-testid="hero-subheadline"
          >
            Individuelles Fußballtraining mit DFB B-Lizenz Trainer. 
            Von 6 Jahren bis Erwachsene – erreiche dein volles Potenzial.
          </p>

          {/* Stats Row */}
          <div
            className="flex flex-wrap gap-6 sm:gap-10 mb-10 animate-fade-in-up opacity-0 stagger-4"
            data-testid="hero-stats"
          >
            <div className="flex items-center gap-3">
              <Award className="w-5 h-5 text-[#c1ff72]" />
              <span className="text-sm text-[#A1A1AA]">DFB B-Lizenz</span>
            </div>
            <div className="flex items-center gap-3">
              <Users className="w-5 h-5 text-[#c1ff72]" />
              <span className="text-sm text-[#A1A1AA]">Einzel & Gruppe</span>
            </div>
            <div className="flex items-center gap-3">
              <MapPin className="w-5 h-5 text-[#c1ff72]" />
              <span className="text-sm text-[#A1A1AA]">4 Standorte</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div
            className="flex flex-col sm:flex-row gap-4 animate-fade-in-up opacity-0 stagger-5"
            data-testid="hero-cta"
          >
            <Link to="/buchen">
              <Button
                size="lg"
                className="w-full sm:w-auto bg-[#c1ff72] hover:bg-[#d4ff9a] text-[#0A0A0A] font-semibold px-8 py-6 text-lg rounded-none transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_0_30px_rgba(193,255,114,0.5)]"
                data-testid="hero-book-button"
              >
                <Calendar className="w-5 h-5 mr-2" />
                JETZT BUCHEN
              </Button>
            </Link>
            <Button
              onClick={scrollToServices}
              variant="outline"
              size="lg"
              className="border-white/20 hover:border-white/40 bg-transparent text-white font-semibold px-8 py-6 text-lg rounded-none transition-all duration-300"
              data-testid="hero-services-button"
            >
              LEISTUNGEN ANSEHEN
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown className="w-8 h-8 text-white/50" />
      </div>
    </section>
  );
};

export default HeroSection;
